// auto-generated by Typewriter template _enums.tst from PortCall.Wartsila.Models\EnhancedEstimateQuery.cs
export enum EnhancedEstimateQueryStatus { 
    Querying = 0,
    Succeeded = 10,
    Failed = 99,
    Unactionable = 98
}

export const EnhancedEstimateQueryStatusDisplayName : { [val : number] : string } = { 
    0: 'Querying',
    10: 'Succeeded',
    99: 'Failed',
    98: 'Unactionable'
}

export const EnhancedEstimateQueryStatuses : { Id : EnhancedEstimateQueryStatus, Name : string }[] = [ 
    { Id: EnhancedEstimateQueryStatus.Querying, Name: 'Querying' },
    { Id: EnhancedEstimateQueryStatus.Succeeded, Name: 'Succeeded' },
    { Id: EnhancedEstimateQueryStatus.Failed, Name: 'Failed' },
    { Id: EnhancedEstimateQueryStatus.Unactionable, Name: 'Unactionable' }
]

export enum UnactionableReason { 
    NoValidVesselIdentifiers = 1,
    NoValidDestinationZone = 2,
    MissingEnhancedEstimatesAutomationConfiguration = 4,
    None = 0
}

export const UnactionableReasonDisplayName : { [val : number] : string } = { 
    1: 'NoValidVesselIdentifiers',
    2: 'NoValidDestinationZone',
    4: 'MissingEnhancedEstimatesAutomationConfiguration',
    0: 'None'
}

export const UnactionableReasons : { Id : UnactionableReason, Name : string }[] = [ 
    { Id: UnactionableReason.NoValidVesselIdentifiers, Name: 'NoValidVesselIdentifiers' },
    { Id: UnactionableReason.NoValidDestinationZone, Name: 'NoValidDestinationZone' },
    { Id: UnactionableReason.MissingEnhancedEstimatesAutomationConfiguration, Name: 'MissingEnhancedEstimatesAutomationConfiguration' },
    { Id: UnactionableReason.None, Name: 'None' }
]



// WEBPACK FOOTER //
// ./server/enums/EnhancedEstimateQuery.ts